import Tooltip, { tooltipClasses } from '@mui/material/Tooltip'
import WarningAmberIcon from '@mui/icons-material/WarningAmber'
import { styled } from '@mui/material/styles'
import {
  COUNTRY_LIST,
  VENDOR_STATUS_OPTIONS,
  RESIDENTIAL_STATUS_OPTIONS,
  TRANSACTION_CATEGORY_OPTIONS,
  GROSSING_UP_OPTIONS,
  NATURE_OF_REMITTANCE_OPTIONS,
  TDS_RATE_BELONGS_TO_OPTIONS,
  REMARKS_OPTIONS,
  MONTH_OPTIONS,
  getMonthLabel
} from './index.js'

export const getErrorMessages = errors =>
  errors.map(err => `ÃƒÂ¢Ã¢â€šÂ¬Ã‚Â¢ ${err.errorMessage}`).join('\n')

// export const TOTAL_COLUMNS_BY_TAB = {
//   adjustments: ["grossExpenseAmount", "tdsBaseAmount", "totalTdsLiability"],
// };

export const TOTAL_KEY_MAPPING = {
  grossExpenseAmount: "totalGrossExpenseAmount",
  tdsBaseAmount: "totalTdsBaseAmount",
  tdsAmount: "totalTdsAmount",
  surcharge: "totalSurcharge",
  educationCess: "totalEducationCess",
  eductionCess: "totalEductionCess",
  interest: "totalInterest",
  totalTdsLiability: "totalTdsLiability",
  others: "totalOthers",
  interestOnLateDeduction: "totalInterest",
  interestOnLateDeposit: "totalInterestOnLateDeposit",
  finalReturnTdsAmount: "finalTdsAmount",
  fu_02: "totalInterestOnLateDeposit"
};



export const WhiteTooltip = styled(({ className, ...props }) => (
  <Tooltip
    {...props}
    arrow
    classes={{ popper: className }}
    PopperProps={{
      disablePortal: false,
    }}
  />
))(({ theme }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: '#fff',
    color: '#000',
    maxWidth: 300,
    fontSize: theme.typography.pxToRem(12),
    boxShadow: '0px 8px 20px rgba(0,0,0,0.3)',
    padding: '8px 12px',
    whiteSpace: 'normal',
    wordBreak: 'break-word',
    maxHeight: 200,
    overflowY: 'auto',
    overflowX: 'hidden',
  },
  [`& .${tooltipClasses.arrow}`]: {
    color: '#fff',
  },
}))



export const statusTabs = [
  {
    label: 'Unprocessed',
    count: 2,
    status: 'unprocessed',
    screenName: 'UNPROCESSED',
  },
  {
    label: 'Processed',
    count: 2,
    status: 'processed',
    screenName: 'PROCESSED',
  },
  {
    label: 'Exceptions',
    count: 1,
    status: 'exceptions',
    screenName: 'EXCEPTION',
  },
  { label: 'Excluded', count: 0, status: 'excluded', screenName: 'EXCLUDED' },
  {
    label: 'Negative entries',
    count: 0,
    status: 'negative',
    screenName: 'NEGATIVE',
    children: [
      { label: 'Unmapped', status: 'unmapped', screenName: 'UNMAPPED', id: 1 },
      { label: 'Mapped', status: 'mapped', screenName: 'MAPPED', id: 2 },
    ],
  },
  {
    label: 'Adjustments',
    count: 0,
    status: 'adjustments',
    screenName: 'ADJUSTMENT',
  },
]

export const getColumnsForTab = (tabStatus, isGenAiEnabled) => {
  const commonColumns = [
    { id: 'vendorPAN', label: 'Vendor pan', minWidth: 120, editable: true },
    { id: 'vendorName', label: 'Vendor name', minWidth: 0, editable: true }, // Adjusted width
    { id: 'year', label: 'Year', minWidth: 100, editable: true, isFormatted: false },
    { id: 'month', label: 'Month', minWidth: 190, editable: true, type: 'dropdown', options: MONTH_OPTIONS },
    {
      id: 'transactionCategory',
      label: 'Transaction category',
      minWidth: 150,
      width: 150,
      type: 'dropdown',
      options: TRANSACTION_CATEGORY_OPTIONS,
      editable: true,
    },
    {
      id: 'grossExpenseAmount',
      label: 'Gross expense amount',
      minWidth: 180,
      width: 150,
      editable: true,
    },
    {
      id: 'tdsBaseAmount',
      label: 'TDS base amount',
      minWidth: 160,
      width: 160,
      editable: true,
    },
    {
      id: 'tdsDetails',
      label: 'TDS detail - as per ERP',
      type: 'group',
      width: '400px',
      minWidth: '400px',
      columns: [
        {
          id: 'tdsSection',
          label: 'TDS section',
          minWidth: 100,
          editable: true,
        },
        { id: 'tdsRate', label: 'TDS rate', minWidth: 100, editable: true },
        { id: 'tdsAmount', label: 'TDS amount', minWidth: 100, editable: true },
      ],
    },
  ]
  let genAiColumn = {
    id: 'tdsDetailsSuggestByTool',
    label: 'TDS detail - suggested by tool',
    type: 'group',
    width: '900px',
    minWidth: '700px',
    background: '#e17700',
    columns: [
      {
        id: 'sbtRuleBasedSection',
        label: 'Rule based section',
        width: 250,
      },
      {
        id: 'sbtGenAIFirstSection',
        label: 'Gen AI 1st section',
        minWidth: 100,
      },
      {
        id: 'sbtReasonFirstSection',
        label: 'Reason for 1st section',
        minWidth: 100,
      },
      {
        id: 'sbtGenAISecondSection',
        label: 'Gen AI 2nd section',
        minWidth: 100,
      },
      {
        id: 'sbtReasonSecondSection',
        label: 'Reason for 2nd section',
        minWidth: 100,
      },
    ],
  }
  if (!isGenAiEnabled) {
    genAiColumn = {
      id: 'tdsDetailsSuggestByTool',
      label: 'TDS detail - suggested by tool',
      type: 'group',
      width: '250px',
      minWidth: '250px',
      background: '#e17700',
      columns: [
        {
          id: 'sbtRuleBasedSection',
          label: 'Rule based section',
          width: 250,
        },
      ],
    }
  }
  if (
    tabStatus === 'processed' ||
    tabStatus === 'exceptions' ||
    tabStatus === 'excluded' ||
    tabStatus === 'adjustments'
  ) {
    const finalReturnColumns = [
      {
        id: 'finalReturnTdsSection',
        label: 'TDS section',
        minWidth: 100,
        editable: true,
      },
      {
        id: 'finalTdsSectionCode',
        label: 'TDS Section Code',
        minWidth: 200,
        editable: false,
        isFormatted: false,
      },
      {
        id: 'finalReturnTdsRate',
        label: 'TDS rate',
        minWidth: 100,
        editable: true,
      },
      {
        id: 'finalReturnTdsAmount',
        label: 'TDS amount',
        minWidth: 100,
        editable: true,
      },
    ]

    return [
      { id: 'loadId', label: 'Load id', minWidth: 80 },
      { id: 'reloadId', label: 'Reload id', minWidth: 80 },
      { id: 'entityTAN', label: 'Entity tan', minWidth: 120 },
            { id: 'fu_01', label: 'Vendor code', minWidth: 120,isFormatted:false },

      ...commonColumns,
      genAiColumn,
      {
        id: 'tdsFinalSuggestedRate',
        label: 'TDS rate suggested on final TDS section',
        minWidth: 100,
        background: '#e17700',
      },
      {
        id: 'reasonTdsFinalSuggestedRate',
        label: 'Reason for TDS rate suggestion',
        minWidth: 0,
        background: '#e17700',
      },

      {
        id: 'status',
        label: 'Status',
        type: 'group',
        width: '250px',
        minWidth: '200px',
        background: '#cf6210',
        columns: [
          { id: 'tdsSectionStatus', label: 'TDS section', minWidth: 100 },
          { id: 'tdsRateStatus', label: 'TDS rate', minWidth: 100 },
        ],
      },
      {
        id: 'tdsDetailsFinalReturn',
        label: 'TDS detail - as per final return',
        type: 'group',
        width: '600px',
        minWidth: '600px',
        background: '#b51c3a',
        columns: finalReturnColumns,
      },
      { id: 'tdsAmountVariance', label: 'TDS amount variance', minWidth: 120, background: '#e17700', },
      { id: 'varianceReason', label: 'Reason for variance', minWidth: 120, background: '#e17700', },
      { id: 'varianceRemark', label: 'Remarks', minWidth: 120, background: '#e17700', },
      { id: 'surcharge', label: 'Surcharge', minWidth: 120 },
      { id: 'educationCess', label: 'Education cess', minWidth: 120 },
      { id: 'totalTdsLiability', label: 'Total TDS liability', minWidth: 120 },
      { id: 'interest', label: 'Interest', minWidth: 80 },
      { id: 'others', label: 'Others', minWidth: 160 },
      { id: 'poDescription', label: 'PO description', minWidth: 180 },
      { id: 'narration', label: 'Narration', minWidth: 100 },
      {
        id: 'expenseGlDescription',
        label: 'Expense GL description',
        minWidth: 120,
      },
      {
        id: 'invoiceDescription',
        label: 'Invoice description',
        minWidth: 120,
      },
      { id: 'hsnCode', label: 'HSN code', minWidth: 100, isFormatted: false },
      { id: 'glCode', label: 'GL code', minWidth: 100, isFormatted: false },
      { id: 'postingDate', label: 'Posting date', minWidth: 120 },
      {
        id: 'dateOfDeduction',
        label: 'Date of deduction',
        type: 'date',
        minWidth: 120,
      },
      { id: 'invoiceNo', label: 'Invoice no.', minWidth: 120, isFormatted: false },
      { id: 'invoiceDate', label: 'Invoice date', minWidth: 120 },
      { id: 'referenceNo', label: 'Reference no.', minWidth: 120, isFormatted: false },
      {
        id: 'referenceDate',
        label: 'Reference date',
        minWidth: 120,
      },
      {
        id: 'accountingDocumentNo',
        label: 'Accounting document no.',
        minWidth: 120,
        isFormatted: false
      },
      {
        id: 'accountingDocumentDate',
        label: 'Accounting document date',
        minWidth: 120,
      },
      {
        id: 'provisionAdjustmentRefNo',
        label: 'Provision adjustment ref. no.',
        minWidth: 160,
        width: 160,
      },
      {
        id: 'advanceAdjustmentRefNo',
        label: 'Advance adjustment ref. no.',
        minWidth: 160,
        width: 160,
      },

      // new column v2
      {
        id: 'accountingDocType',
        label: 'Accounting doc. type',
        minWidth: 160,
        width: 160,
        isFormatted: false
      },
      {
        id: 'debitCreditIndicator',
        label: 'Debit/credit indicator',
        minWidth: 160,
        width: 160,
        isFormatted: false
      },
      {
        id: 'cancelledFlag',
        label: 'Cancelled flag',
        minWidth: 160,
        width: 160,
        isFormatted: false
      },
      {
        id: 'tdsAccountGlCode',
        label: 'TDS account GL code',
        minWidth: 160,
        width: 160,
        isFormatted: false
      },
      {
        id: 'operatingUnit',
        label: 'Operating unit',
        minWidth: 160,
        width: 160,
        isFormatted: false
      },
      {
        id: 'poNo',
        label: 'PO no',
        minWidth: 150,
        width: 150,
        isFormatted: false
      },
      {
        id: 'entryDate',
        label: 'Entry date',
        minWidth: 150,
        width: 150,
      },
      {
        id: 'projectCode',
        label: 'Project code',
        minWidth: 160,
        width: 160,
        isFormatted: false
      },
      {
        id: 'currency',
        label: 'Currency',
        minWidth: 100,
        width: 100,
        isFormatted: false
      },
      {
        id: 'exchangeRate',
        label: 'Exchange rate',
        minWidth: 160,
        width: 160,
        isFormatted: false
      },
      {
        id: 'exchangeType',
        label: 'Exchange type',
        minWidth: 160,
        width: 160,
        isFormatted: false
      },
      {
        id: 'offsetGlCode',
        label: 'Offset GL code',
        minWidth: 160,
        width: 160,
        isFormatted: false
      },
      {
        id: 'tdsEntry',
        label: 'TDS entry',
        minWidth: 160,
        width: 160,
      },
      {
        id: 'whtType',
        label: 'WHT type',
        minWidth: 160,
        width: 160,
        isFormatted: false
      },
      {
        id: 'whtTaxCode',
        label: 'WHT tax code',
        minWidth: 160,
        width: 160,
        isFormatted: false
      },
      {
        id: 'source',
        label: 'Source',
        minWidth: 160,
        width: 160,
        isFormatted: false
      },
      {
        id: 'duplicateReferenceNumber',
        label: 'Duplicate reference number',
        minWidth: 180,
        width: 180,
        isFormatted: false
      },



      { id: 'excluded', label: 'Excluded', minWidth: 120 },
      {
        id: 'vendorStatus',
        label: 'Vendor status',
        minWidth: 120,
        editable: true,
        type: 'dropdown',
        options: VENDOR_STATUS_OPTIONS,
      },
      {
        id: 'remarks',
        label:
          'Remarks (Reason for non-deduction / Lower deduction/ higher deduction/ threshold)',
        minWidth: 300,
        width: 400,
        maxWidth: 400,
        align: 'center',
      },
      {
        id: 'certificateNumber',
        label:
          'Certificate number issued by the  Assessing Officer u/s 197 for non-deduction/ lower deduction ',
        minWidth: 300,
        width: 400,
        maxWidth: 400,
        align: 'center',
      },
      { id: 'challanSerialNo', label: 'Challan serial no.', minWidth: 150, isFormatted: false },
      { id: 'bsrCode', label: 'BSR code', minWidth: 120, isFormatted: false },
      {
        id: 'dateOfTaxDeposited',
        label: 'Date of tax deposited',
        width: 150,
      },
      {
        id: 'totalTaxDeposited',
        label: 'Total tax deposited',
        width: 120,
      },
      {
        id: 'fu_02',
        label: 'Interest on late deposit',
        width: 120,
      },
      {
        id: 'paidByBookEntry',
        label: 'Paid by book entry or otherwise',
        width: 150,
      },
      {
        id: 'accountingMonth',
        label: 'Accounting month',
        width: 150,
        render: (value) => getMonthLabel(value),

      },
      {
        id: 'accountingYear',
        label: 'Accounting year',
        width: 150,
        isFormatted: false
      },
      {
        id: 'residentialStatus',
        label: 'Residential status',
        minWidth: 140,
        type: 'dropdown',
        options: RESIDENTIAL_STATUS_OPTIONS,
      },

      {
        id: 'grossingUpIndicator',
        label: 'Grossing up indicator',
        minWidth: 0,
      },
      {
        id: 'natureOfRemittance',
        label: 'Nature of remittance',
        minWidth: 0,
      },
      {
        id: 'tdsRateBasis',
        label: 'TDS rate belongs to IT act or DTAA',
        minWidth: 0,
      },
      { id: 'tinUin', label: 'TIN/UIN', minWidth: 150 },
      {
        id: 'uniqueAcknowledgement15CA',
        label:
          'Unique acknowledgement of the corresponding form no. 15CA (if available)',
        minWidth: 350,
        width: 350,
      },
      {
        id: 'vendorCountry',
        label: "Vendor's country of residence",
        minWidth: 0,
        align: 'center',
      },
      { id: 'vendorEmail', label: 'Vendor email ID', minWidth: 0 },
      {
        id: 'vendorContact',
        label: 'Vendor contact number',
        minWidth: 0,
        isFormatted: false
      },
      { id: 'vendorAddress', label: 'Vendor address', minWidth: 0 },
      {
        id: 'vendorReferenceNo',
        label: 'Vendor  Reference No.  Provided by the Deductor  (if available)',
        minWidth: 0,
        width: 350,
      },
      {
        id: 'panAadharLinking',
        label: 'Vendor pan linking with Aadhar',
        minWidth: 0,
        width: 350,
      },

      ...Array.from({ length: 20 }, (_, i) => ({
        id: `mis${i + 1}`,
        label: `MIS ${i + 1}`,
        minWidth: 100,
      })),

      // FU 3–20 (FU_01 is "Vendor Code", FU_02 is "Interest on late deposit")
      ...Array.from({ length: 18 }, (_, i) => {
        const num = String(i + 3).padStart(2, '0');
        return {
          id: `fu_${num}`,
          label: `FU_${num}`,
          minWidth: 100,
        };
      }),
    ]
  } else if (tabStatus === 'unprocessed') {
    return [
      // { id: 'errorCount', label: 'Error count', minWidth: 100 },
      {
        id: 'errorCount',
        label: 'Error count',
        minWidth: 100,
        render: (value, row) => {
          const errors = row?.errorList || []
          const errorCount = row?.errorCount
          if (!errorCount) return null

          return (
            <WhiteTooltip
              placement="bottom-start"
              title={
                <div>
                  {errors.map((err, i) => (
                    <div key={i} className="flex items-start gap-2 my-2">
                      <span className="w-3 h-3 bg-red-500 inline-block mt-1"></span>
                      <span className="text-sm leading-snug">
                        {err.errorMessage}
                      </span>
                    </div>
                  ))}
                </div>
              }
              arrow
            >
              <div className="flex items-center gap-2 cursor-pointer">
                <WarningAmberIcon style={{ color: '#E0301E' }} />
                <span>{errorCount}</span>
              </div>
            </WhiteTooltip>
          )
        },
      },
      { id: 'loadId', label: 'Load id', minWidth: 80 },
      { id: 'reloadId', label: 'Reload id', minWidth: 80 },
      { id: 'entityTAN', label: 'Entity tan', minWidth: 120, editable: true },
      { id: 'fu_01', label: 'Vendor code', minWidth: 120,isFormatted:false },

      ...commonColumns,
      { id: 'surcharge', label: 'Surcharge', minWidth: 120, editable: true },
      {
        id: 'educationCess',
        label: 'Education cess',
        minWidth: 120,
        editable: true,
      },
      {
        id: 'totalTdsLiability',
        label: 'Total TDS liability',
        minWidth: 120,
        editable: true,
      },
      { id: 'interest', label: 'Interest', minWidth: 80, editable: true },
      { id: 'others', label: 'Others', minWidth: 160, editable: true },
      {
        id: 'poDescription',
        label: 'PO description',
        minWidth: 180,
        editable: true,
      },
      { id: 'narration', label: 'Narration', minWidth: 100, editable: true },
      {
        id: 'expenseGlDescription',
        label: 'Expense GL description',
        minWidth: 120,
        editable: true,
      },
      {
        id: 'invoiceDescription',
        label: 'Invoice description',
        minWidth: 120,
        editable: true,
      },
      { id: 'hsnCode', label: 'HSN code', minWidth: 100, editable: true, isFormatted: false },
      { id: 'glCode', label: 'GL code', minWidth: 100, editable: true, isFormatted: false },
      {
        id: 'postingDate',
        label: 'Posting date',
        minWidth: 120,
        editable: true,
        type: 'date',
      },
      {
        id: 'dateOfDeduction',
        label: 'Date of deduction',
        minWidth: 120,
        editable: true,
        type: 'date',
      },
      { id: 'invoiceNo', label: 'Invoice no.', minWidth: 120, editable: true, isFormatted: false },
      {
        id: 'invoiceDate',
        label: 'Invoice date',
        minWidth: 120,
        editable: true,
      },
      {
        id: 'referenceNo',
        label: 'Reference no.',
        minWidth: 120,
        editable: true,
        isFormatted: false
      },
      {
        id: 'referenceDate',
        label: 'Reference date',
        minWidth: 120,
      },
      {
        id: 'accountingDocumentNo',
        label: 'Accounting document no.',
        minWidth: 120,
        editable: true,
        isFormatted: false
      },
      {
        id: 'accountingDocumentDate',
        label: 'Accounting document date',
        minWidth: 120,
        editable: true,
      },
      {
        id: 'provisionAdjustmentRefNo',
        label: 'Provision adjustment ref. no.',
        minWidth: 160,
        width: 160,
      },
      {
        id: 'advanceAdjustmentRefNo',
        label: 'Advance adjustment ref. no.',
        minWidth: 160,
        width: 160,
      },
      {
        id: 'accountingDocType',
        label: 'Accounting doc. type',
        minWidth: 160,
        width: 160,
        isFormatted: false
      },
      {
        id: 'debitCreditIndicator',
        label: 'Debit/credit indicator',
        minWidth: 160,
        width: 160,
        isFormatted: false
      },
      {
        id: 'cancelledFlag',
        label: 'Cancelled flag',
        minWidth: 160,
        width: 160,
        isFormatted: false
      },
      {
        id: 'tdsAccountGlCode',
        label: 'TDS account GL code',
        minWidth: 160,
        width: 160,
        isFormatted: false
      },
      {
        id: 'operatingUnit',
        label: 'Operating unit',
        minWidth: 160,
        width: 160,
        isFormatted: false
      },
      {
        id: 'poNo',
        label: 'PO no',
        minWidth: 150,
        width: 150,
        isFormatted: false
      },
      {
        id: 'entryDate',
        label: 'Entry date',
        minWidth: 150,
        width: 150,
      },
      {
        id: 'projectCode',
        label: 'Project code',
        minWidth: 160,
        width: 160,
        isFormatted: false
      },
      {
        id: 'currency',
        label: 'Currency',
        minWidth: 100,
        width: 100,
        isFormatted: false
      },
      {
        id: 'exchangeRate',
        label: 'Exchange rate',
        minWidth: 160,
        width: 160,
        isFormatted: false
      },
      {
        id: 'exchangeType',
        label: 'Exchange type',
        minWidth: 160,
        width: 160,
        isFormatted: false
      },
      {
        id: 'offsetGlCode',
        label: 'Offset GL code',
        minWidth: 160,
        width: 160,
        isFormatted: false
      },
      {
        id: 'tdsEntry',
        label: 'TDS entry',
        minWidth: 160,
        width: 160,
      },
      {
        id: 'whtType',
        label: 'WHT type',
        minWidth: 160,
        width: 160,
        isFormatted: false
      },
      {
        id: 'whtTaxCode',
        label: 'WHT tax code',
        minWidth: 160,
        width: 160,
        isFormatted: false
      },
      {
        id: 'source',
        label: 'Source',
        minWidth: 160,
        width: 160,
        isFormatted: false
      },
      {
        id: 'duplicateReferenceNumber',
        label: 'Duplicate reference number',
        minWidth: 180,
        width: 180,
        isFormatted: false
      },
      {
        id: 'vendorStatus',
        label: 'Vendor status',
        minWidth: 120,
        editable: true,
        type: 'dropdown',
        options: VENDOR_STATUS_OPTIONS,
      },

      // ÃƒÂ°Ã…Â¸Ã¢â‚¬ÂÃ‚Â½ Newly added columns
      {
        id: 'remarks',
        label:
          'Remarks (Reason for non-deduction / Lower deduction/ higher deduction/ threshold)',
        minWidth: 300,
        width: 400,
        maxWidth: 400,
        editable: true,
        align: 'center',
        type: 'dropdown',
        options: REMARKS_OPTIONS
      },
      {
        id: 'certificateNumber',
        label:
          'Certificate number issued by the  Assessing Officer u/s 197 for non-deduction/ lower deduction ',
        minWidth: 300,
        width: 400,
        maxWidth: 400,
        editable: true,
        align: 'center',
      },
      {
        id: 'challanSerialNo',
        label: 'Challan serial no.',
        minWidth: 150,
        isFormatted: false,
        editable: true,
      },
      { id: 'bsrCode', label: 'BSR code', minWidth: 120, editable: true, isFormatted: false },
      {
        id: 'dateOfTaxDeposited',
        label: 'Date of tax deposited',
        width: 150,
        editable: true,
      },
      {
        id: 'totalTaxDeposited',
        label: 'Total tax deposited',
        width: 120,
        editable: true,
      },
      {
        id: 'fu_02',
        label: 'Interest on late deposit',
        width: 120
      },
      {
        id: 'paidByBookEntry',
        label: 'Paid by book entry or otherwise',
        width: 150,
        editable: true,
      },
      {
        id: 'accountingMonth',
        label: 'Accounting month',
        width: 150,
        render: (value) => getMonthLabel(value),
      },
      {
        id: 'accountingYear',
        label: 'Accounting year',
        width: 150,
        isFormatted: false
      },
      {
        id: 'residentialStatus',
        label: 'Residential status',
        minWidth: 140,
        editable: true,
        type: 'dropdown',
        options: RESIDENTIAL_STATUS_OPTIONS,
      },

      {
        id: 'grossingUpIndicator',
        label: 'Grossing up indicator',
        minWidth: 180,
        editable: true,
        type: 'dropdown',
        options: GROSSING_UP_OPTIONS
      },
      {
        id: 'natureOfRemittance',
        label: 'Nature of remittance',
        minWidth: 180,
      },
      {
        id: 'tdsRateBasis',
        label: 'TDS rate belongs to IT act or DTAA',
        minWidth: 220,
        editable: true,
        type: 'dropdown',
        options: TDS_RATE_BELONGS_TO_OPTIONS
      },
      {
        id: 'uniqueAcknowledgement15CA',
        label:
          'Unique acknowledgement of the corresponding form no. 15CA (if available)',
        minWidth: 350,
        width: 350,
        editable: true,
      },
      {
        id: 'vendorCountry',
        label: "Vendor's country of residence",
        minWidth: 220,
        editable: true,
        align: 'center',
        type: 'dropdown',
        options: COUNTRY_LIST,
      },
      {
        id: 'vendorEmail',
        label: 'Vendor email ID',
        minWidth: 200,
        editable: true,
      },
      {
        id: 'vendorContact',
        label: 'Vendor contact number',
        minWidth: 200,
        editable: true,
        isFormatted: false
      },
      {
        id: 'vendorAddress',
        label: 'Vendor address',
        minWidth: 220,
        editable: true,
      },
      {
        id: 'vendorReferenceNo',
        label: 'Vendor  Reference No.  Provided by the Deductor  (if available)',
        minWidth: 0,
        width: 350,
        editable: true,
      },
      {
        id: 'panAadharLinking',
        label: 'Vendor pan linking with Aadhar',
        minWidth: 0,
        width: 350,
      },
      { id: 'tinUin', label: 'TIN/UIN', minWidth: 150, editable: true },

      ...Array.from({ length: 20 }, (_, i) => ({
        id: `mis${i + 1}`,
        label: `MIS ${i + 1}`,
        minWidth: 100,
        editable: true,
      })),

      // FU 3–20 (FU_01 is "Vendor Code", FU_02 is "Interest on late deposit")
      ...Array.from({ length: 18 }, (_, i) => {
        const num = String(i + 3).padStart(2, '0');
        return {
          id: `fu_${num}`,
          label: `FU_${num}`,
          minWidth: 100,
        };
      }),
    ]
  } else if (tabStatus === 'unmapped') {
    return [
      { id: 'loadId', label: 'Load id', minWidth: 80 },
      { id: 'reloadId', label: 'Reload id', minWidth: 80 },
      { id: 'entityTAN', label: 'Entity tan', minWidth: 120 },
      { id: 'fu_01', label: 'Vendor code', minWidth: 120,isFormatted:false },

      ...commonColumns,
      { id: 'surcharge', label: 'Surcharge', minWidth: 120 },
      { id: 'educationCess', label: 'Education cess', minWidth: 120 },
      { id: 'totalTdsLiability', label: 'Total TDS liability', minWidth: 120 },
      { id: 'interest', label: 'Interest', minWidth: 80 },
      { id: 'others', label: 'Others', minWidth: 160 },
      { id: 'poDescription', label: 'PO description', minWidth: 180 },
      { id: 'narration', label: 'Narration', minWidth: 100 },
      {
        id: 'expenseGlDescription',
        label: 'Expense GL description',
        minWidth: 120,
      },
      {
        id: 'invoiceDescription',
        label: 'Invoice description',
        minWidth: 120,
      },
      { id: 'hsnCode', label: 'HSN code', minWidth: 100, isFormatted: false },
      { id: 'glCode', label: 'GL code', minWidth: 100, isFormatted: false },
      { id: 'postingDate', label: 'Posting date', minWidth: 120 },
      {
        id: 'dateOfDeduction',
        label: 'Date of deduction',
        type: 'date',
        minWidth: 120,
      },
      { id: 'invoiceNo', label: 'Invoice no.', minWidth: 120, isFormatted: false },
      { id: 'invoiceDate', label: 'Invoice date', minWidth: 120 },
      { id: 'referenceNo', label: 'Reference no.', minWidth: 120, isFormatted: false },
      {
        id: 'referenceDate',
        label: 'Reference date',
        minWidth: 120,
      },
      {
        id: 'accountingDocumentNo',
        label: 'Accounting document no.',
        minWidth: 120,
        isFormatted: false
      },
      { id: 'excluded', label: 'Excluded', minWidth: 120 },
      {
        id: 'accountingDocumentDate',
        label: 'Accounting document date',
        minWidth: 120,
      },
      {
        id: 'provisionAdjustmentRefNo',
        label: 'Provision adjustment ref. no.',
        minWidth: 160,
        width: 160,
      },
      {
        id: 'advanceAdjustmentRefNo',
        label: 'Advance adjustment ref. no.',
        minWidth: 160,
        width: 160,
      },
      {
        id: 'accountingDocType',
        label: 'Accounting doc. type',
        minWidth: 160,
        width: 160,
        isFormatted: false
      },
      {
        id: 'debitCreditIndicator',
        label: 'Debit/credit indicator',
        minWidth: 160,
        width: 160,
        isFormatted: false
      },
      {
        id: 'cancelledFlag',
        label: 'Cancelled flag',
        minWidth: 160,
        width: 160,
        isFormatted: false
      },
      {
        id: 'tdsAccountGlCode',
        label: 'TDS account GL code',
        minWidth: 160,
        width: 160,
        isFormatted: false
      },
      {
        id: 'operatingUnit',
        label: 'Operating unit',
        minWidth: 160,
        width: 160,
        isFormatted: false
      },
      {
        id: 'poNo',
        label: 'PO no',
        minWidth: 150,
        width: 150,
        isFormatted: false
      },
      {
        id: 'entryDate',
        label: 'Entry date',
        minWidth: 150,
        width: 150,
      },
      {
        id: 'projectCode',
        label: 'Project code',
        minWidth: 160,
        width: 160,
        isFormatted: false
      },
      {
        id: 'currency',
        label: 'Currency',
        minWidth: 100,
        width: 100,
        isFormatted: false
      },
      {
        id: 'exchangeRate',
        label: 'Exchange rate',
        minWidth: 160,
        width: 160,
        isFormatted: false
      },
      {
        id: 'exchangeType',
        label: 'Exchange type',
        minWidth: 160,
        width: 160,
        isFormatted: false
      },
      {
        id: 'offsetGlCode',
        label: 'Offset GL code',
        minWidth: 160,
        width: 160,
        isFormatted: false
      },
      {
        id: 'tdsEntry',
        label: 'TDS entry',
        minWidth: 160,
        width: 160,
      },
      {
        id: 'whtType',
        label: 'WHT type',
        minWidth: 160,
        width: 160,
        isFormatted: false
      },
      {
        id: 'whtTaxCode',
        label: 'WHT tax code',
        minWidth: 160,
        width: 160,
        isFormatted: false
      },
      {
        id: 'source',
        label: 'Source',
        minWidth: 160,
        width: 160,
        isFormatted: false
      },
      {
        id: 'duplicateReferenceNumber',
        label: 'Duplicate reference number',
        minWidth: 180,
        width: 180,
        isFormatted: false
      },
      {
        id: 'vendorStatus',
        label: 'Vendor status',
        minWidth: 120,
        editable: true,
        type: 'dropdown',
        options: VENDOR_STATUS_OPTIONS,
      },

      // ÃƒÂ°Ã…Â¸Ã¢â‚¬ÂÃ‚Â½ Newly added columns
      {
        id: 'remarks',
        label:
          'Remarks (Reason for non-deduction / Lower deduction/ higher deduction/ threshold)',
        minWidth: 300,
        width: 400,
        maxWidth: 400,
        align: 'center',
      },
      {
        id: 'certificateNumber',
        label:
          'Certificate number issued by the  Assessing Officer u/s 197 for non-deduction/ lower deduction ',
        minWidth: 300,
        width: 400,
        maxWidth: 400,
        align: 'center',
      },
      { id: 'challanSerialNo', label: 'Challan serial no.', minWidth: 150, isFormatted: false },
      { id: 'bsrCode', label: 'BSR code', minWidth: 120, isFormatted: false },
      {
        id: 'dateOfTaxDeposited',
        label: 'Date of tax deposited',
        width: 150,
      },
      {
        id: 'totalTaxDeposited',
        label: 'Total tax deposited',
        width: 120,
      },
      {
        id: 'fu_02',
        label: 'Interest on late deposit',
        width: 120,
      },
      {
        id: 'paidByBookEntry',
        label: 'Paid by book entry or otherwise',
        width: 150,
      },
      {
        id: 'accountingMonth',
        label: 'Accounting month',
        width: 150,
        render: (value) => getMonthLabel(value),

      },
      {
        id: 'accountingYear',
        label: 'Accounting year',
        width: 150,
        isFormatted: false
      },
      {
        id: 'residentialStatus',
        label: 'Residential status',
        minWidth: 140,
        type: 'dropdown',
        options: RESIDENTIAL_STATUS_OPTIONS,
      },

      {
        id: 'grossingUpIndicator',
        label: 'Grossing up indicator',
        minWidth: 180,
      },
      {
        id: 'natureOfRemittance',
        label: 'Nature of remittance',
        minWidth: 180,
      },
      {
        id: 'tdsRateBasis',
        label: 'TDS rate belongs to IT act or DTAA',
        minWidth: 220,
      },
      {
        id: 'uniqueAcknowledgement15CA',
        label:
          'Unique acknowledgement of the corresponding form no. 15CA (if available)',
        minWidth: 350,
        width: 350,
      },
      {
        id: 'vendorCountry',
        label: "Vendor's country of residence",
        minWidth: 220,
        align: 'center',
      },
      { id: 'vendorEmail', label: 'Vendor email ID', minWidth: 200 },
      {
        id: 'vendorContact',
        label: 'Vendor contact number',
        minWidth: 200,
        isFormatted: false
      },
      { id: 'vendorAddress', label: 'Vendor address', minWidth: 220 },
      {
        id: 'vendorReferenceNo',
        label: 'Vendor  Reference No.  Provided by the Deductor  (if available)',
        minWidth: 0,
        width: 350,
      },
      {
        id: 'panAadharLinking',
        label: 'Vendor pan linking with Aadhar',
        minWidth: 0,
        width: 350,
      },
      { id: 'tinUin', label: 'TIN/UIN', minWidth: 150 },

      ...Array.from({ length: 20 }, (_, i) => ({
        id: `mis${i + 1}`,
        label: `MIS ${i + 1}`,
        minWidth: 100,
      })),

      // FU 3–20 (FU_01 is "Vendor Code", FU_02 is "Interest on late deposit")
      ...Array.from({ length: 18 }, (_, i) => {
        const num = String(i + 3).padStart(2, '0');
        return {
          id: `fu_${num}`,
          label: `FU_${num}`,
          minWidth: 100,
        };
      }),
    ]
  } else if (tabStatus === 'mapped') {
    return [
      { id: 'loadId', label: 'Load id', minWidth: 80 },
      { id: 'reloadId', label: 'Reload id', minWidth: 80 },
      { id: 'entityTAN', label: 'Entity tan', minWidth: 120 },
      { id: 'fu_01', label: 'Vendor code', minWidth: 120 },
      ...commonColumns,
      { id: 'surcharge', label: 'Surcharge', minWidth: 120 },
      { id: 'educationCess', label: 'Education cess', minWidth: 120 },
      { id: 'totalTdsLiability', label: 'Total TDS liability', minWidth: 120 },
      { id: 'interest', label: 'Interest', minWidth: 80 },
      { id: 'others', label: 'Others', minWidth: 160 },
      { id: 'poDescription', label: 'PO description', minWidth: 180 },
      { id: 'narration', label: 'Narration', minWidth: 100 },
      {
        id: 'expenseGlDescription',
        label: 'Expense GL description',
        minWidth: 120,
      },
      {
        id: 'invoiceDescription',
        label: 'Invoice description',
        minWidth: 120,
      },
      { id: 'hsnCode', label: 'HSN code', minWidth: 100, isFormatted: false },
      { id: 'glCode', label: 'GL code', minWidth: 100, isFormatted: false },
      { id: 'postingDate', label: 'Posting date', minWidth: 120 },
      {
        id: 'dateOfDeduction',
        label: 'Date of deduction',
        type: 'date',
        minWidth: 120,
      },
      { id: 'invoiceNo', label: 'Invoice no.', minWidth: 120, isFormatted: false },
      { id: 'invoiceDate', label: 'Invoice date', minWidth: 120 },
      { id: 'referenceNo', label: 'Reference no.', minWidth: 120, isFormatted: false },
      {
        id: 'referenceDate',
        label: 'Reference date',
        minWidth: 120,
      },
      {
        id: 'accountingDocumentNo',
        label: 'Accounting document no.',
        minWidth: 120,
        isFormatted: false
      },
      {
        id: 'accountingDocumentDate',
        label: 'Accounting document date',
        minWidth: 120,
      },
      { id: 'excluded', label: 'Excluded', minWidth: 120 },
    ]
  } else {
    return [
      ...commonColumns,
      { id: 'surcharge', label: 'Surcharge', minWidth: 120 },
      { id: 'educationCess', label: 'Education cess', minWidth: 120 },
      { id: 'totalTdsLiability', label: 'Total TDS liability', minWidth: 120 },
      { id: 'interest', label: 'Interest', minWidth: 80 },
      { id: 'others', label: 'Others', minWidth: 160 },
      { id: 'poDescription', label: 'PO description', minWidth: 180 },
      { id: 'narration', label: 'Narration', minWidth: 100 },
      {
        id: 'expenseGlDescription',
        label: 'Expense GL description',
        minWidth: 120,
      },
      {
        id: 'invoiceDescription',
        label: 'Invoice description',
        minWidth: 120,
      },
      { id: 'hsnCode', label: 'HSN code', minWidth: 100, isFormatted: false },
      { id: 'glCode', label: 'GL code', minWidth: 100, isFormatted: false },
      { id: 'postingDate', label: 'Posting date', minWidth: 120 },
      {
        id: 'dateOfDeduction',
        label: 'Date of deduction',
        type: 'date',
        minWidth: 120,
      },
      { id: 'invoiceNo', label: 'Invoice no.', minWidth: 120, isFormatted: false },
      { id: 'invoiceDate', label: 'Invoice date', minWidth: 120 },
      { id: 'referenceNo', label: 'Reference no.', minWidth: 120, isFormatted: false },
      {
        id: 'referenceDate',
        label: 'Reference date',
        minWidth: 120,
      },
      {
        id: 'accountingDocumentNo',
        label: 'Accounting document no.',
        minWidth: 120,
        isFormatted: false
      },
      {
        id: 'accountingDocumentDate',
        label: 'Accounting document date',
        minWidth: 120,
      },
      { id: 'excluded', label: 'Excluded', minWidth: 120 },
      {
        id: 'vendorStatus',
        label: 'Vendor status',
        minWidth: 120,
        editable: true,
        type: 'dropdown',
        options: VENDOR_STATUS_OPTIONS,
      },
      // ÃƒÂ°Ã…Â¸Ã¢â‚¬ÂÃ‚Â½ Newly added columns
      {
        id: 'remarks',
        label:
          'Remarks (Reason for non-deduction / Lower deduction/ higher deduction/ threshold)',
        minWidth: 300,
        width: 400,
        maxWidth: 400,
        align: 'center',
      },
      {
        id: 'certificateNumber',
        label:
          'Certificate number issued by the  Assessing Officer u/s 197 for non-deduction/ lower deduction ',
        minWidth: 300,
        width: 400,
        maxWidth: 400,
        align: 'center',
      },
      { id: 'challanSerialNo', label: 'Challan serial no.', minWidth: 150, isFormatted: false },
      { id: 'bsrCode', label: 'BSR code', minWidth: 120, isFormatted: false },
      {
        id: 'dateOfTaxDeposited',
        label: 'Date of tax deposited',
        width: 150,
      },
      {
        id: 'totalTaxDeposited',
        label: 'Total tax deposited',
        width: 120,
      },
      {
        id: 'fu_02',
        label: 'Interest on late deposit',
        width: 120,
      },
      {
        id: 'paidByBookEntry',
        label: 'Paid by book entry or otherwise',
        width: 150,
      },
      {
        id: 'accountingMonth',
        label: 'Accounting month',
        width: 150,
        render: (value) => getMonthLabel(value),

      },
      {
        id: 'accountingYear',
        label: 'Accounting year',
        width: 150,
        isFormatted: false
      },
      {
        id: 'residentialStatus',
        label: 'Residential status',
        minWidth: 140,
        type: 'dropdown',
        options: RESIDENTIAL_STATUS_OPTIONS,
      },

      {
        id: 'grossingUpIndicator',
        label: 'Grossing up indicator',
        minWidth: 180,
      },
      {
        id: 'natureOfRemittance',
        label: 'Nature of remittance',
        minWidth: 180,
      },
      {
        id: 'tdsRateBasis',
        label: 'TDS rate belongs to IT act or DTAA',
        minWidth: 220,
      },
      {
        id: 'uniqueAcknowledgement15CA',
        label:
          'Unique acknowledgement of the corresponding form no. 15CA (if available)',
        minWidth: 350,
        width: 350,
      },
      {
        id: 'vendorCountry',
        label: "Vendor's country of residence",
        minWidth: 220,
        align: 'center',
      },
      { id: 'vendorEmail', label: 'Vendor email ID', minWidth: 200 },
      {
        id: 'vendorContact',
        label: 'Vendor contact number',
        minWidth: 200,
        isFormatted: false
      },
      { id: 'vendorAddress', label: 'Vendor address', minWidth: 220 },
      {
        id: 'vendorReferenceNo',
        label: 'Vendor  Reference No.  Provided by the Deductor  (if available)',
        minWidth: 0,
        width: 350,
      },
      {
        id: 'panAadharLinking',
        label: 'Vendor pan linking with Aadhar',
        minWidth: 0,
        width: 350,
      },
      { id: 'tinUin', label: 'TIN/UIN', minWidth: 150 },

      ...Array.from({ length: 20 }, (_, i) => ({
        id: `mis${i + 1}`,
        label: `MIS ${i + 1}`,
        minWidth: 100,
      })),

      // FU 3–20 (FU_01 is "Vendor Code", FU_02 is "Interest on late deposit")
      ...Array.from({ length: 18 }, (_, i) => {
        const num = String(i + 3).padStart(2, '0');
        return {
          id: `fu_${num}`,
          label: `FU_${num}`,
          minWidth: 100,
        };
      }),
    ]
  }
}

export const ACTIONS = {
  EXCLUDE: 'EXCLUDED',
  INCLUDE: 'PROCESSED',
}

export const PREPARE_TABS = {
  UNPROCESSED: 'UNPROCESSED',
  PROCESSED: 'PROCESSED',
  EXCEPTION: 'EXCEPTION',
  NEGATIVE: 'NEGATIVE',
  UNMAPPED: 'UNMAPPED',
  MAPPED: 'MAPPED',
  ADJUSTMENT: 'ADJUSTMENT'
}